import React, { useCallback } from "react";
// import { useHistory } from "react-router-dom";
/*
import { Link } from "react-router-dom";

import { loadTemplateFile } from '../tools/layout-tool';

import { promiseFetchDataAuth } from 'crk-front-lib';
// eslint-disable-next-line no-unused-vars
import { showAlert } from '../zeta-widget/tools/alert-tool';
import { ZetaGroup } from "../zeta-widget";
*/
export function SubscribePage(props) {
  // const auth = useAuth();
  /*
  const [appTemplate, setAppTemplate] = useState([]);

  useEffect(() => {
    loadTemplateFile('member-subscr', (result) => {
      setAppTemplate(result);
    })
  },[]);
  /*
  /*
  Browser security not allow open popup directy,
  It must be call from user clicking ONLY
  */
  const handleSubscribe = useCallback(
    () => {
      window.popupSubscribe();  
    },
    [],
  )

  return (
    <div className="row justify-content-center">
      <div className="col-xl-10 col-lg-12 col-md-9">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            {/* Nested Row within Card Body */}
            <div className="row p-3">
              <div className="col-lg-6 d-none d-lg-block bg-password-image"></div>
                <div className="col-lg-6">
                  <div className="text-center">
                    <h1 className="h4 text-gray-900 mb-2">Package Subscription</h1>
                    <p className="mx-4 mb-4">การสมัครใช้งานโปรแกรม</p>
                  </div>

                  <p>
                    สำหรับสมาชิกใหม่ คลิกที่ปุ่ม สมัครสมาชิก เพื่อเริ่มใช้งานโปรแกรม
                  </p>
                  <button id='btnSubscribe' 
                    type="button" 
                    className="btn btn-primary btn-user w-40" 
                    onClick={handleSubscribe}>สมัครใช้งาน</button>
                  <hr />
                  <br />

                  <p>
                    สำหรับสมาชิกที่หมดอายุการใช้งานแล้ว กรุณาชำระเงิน<br />
                    และ แจ้งชำระเงิน ได้ที่ปุ่มด้านล่างนี้
                  </p>

                  <button id='btnSubscribe' 
                    type="button" 
                    className="btn btn-primary btn-user w-40" 
                    onClick={() => {
                      window.crkStore.payment();
                    }}>แจ้งชำระเงิน</button>
                  &nbsp;&nbsp;
                  <button id='btnSubscribe' 
                    type="button" 
                    className="btn btn-light btn-user w-40" 
                    onClick={() => {
                      window.crkStore.openPindingBill();
                    }}>รายการบิลค้างชำระ</button>

                  <hr />
                  <p>
                    สมาชิกที่หมดอายุเกิน 7 วัน กรุณา 
                    <a className="btn btn-light" href="/welcome.html#contact">ติดต่อเจ้าหน้าที่</a>
                  </p>
                  <br />
                  ต้องการรายละเอียดเกี่ยวกับสถานะสมาชิก คลิก &nbsp;
                  <button 
                    type="button"
                    className="btn btn-light"
                    onClick={() => window.crkStore.openStoreHome()}>CRK Store</button>
                  <br />
                  <br />
              </div>
              {/* end right panel */}
            </div>
            {/* end of row */}
          </div>
        </div>
        {/* end of card */}
      </div>
    </div>
  )
  /* <div>
    <p>
      คลิกปุ่มด้านล่าง เพื่อ สมัครใช้งาน
    </p>
    <button id='btnSubscribe' onClick={handleSubscribe}>เปิดหน้าจอสมัครใช้งาน</button>
  </div> */
}